'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'font';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f031';
var svgPathData = 'M256 32c3.3 0 6.2 2 7.4 5l174 427 50.6 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-128 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l60.1 0-52.1-128-223.9 0-52.1 128 60.1 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L24 480c-4.4 0-8-3.6-8-8s3.6-8 8-8l50.6 0 174-427c1.2-3 4.2-5 7.4-5zM150.6 320L361.4 320 256 61.2 150.6 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFont = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;